import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { OneNoteProgId, SharePointFolderContentTypeIds } from "../../../src/taskpane/config/constants";
import { RootState } from "../../../src/taskpane/redux";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { InfoPanelMode } from "../../Panels/CMFileInfoPanel";
import { CheckinCheckoutHelper } from "../../../utilities/CheckinCheckoutHelper";

export function useMenuItem_Replace(selectedItems: any[], waitFor: boolean, setIsCMFileInfoPanelOpen: (isCMFileInfoPanelOpen: boolean) => void, setInfoPanelMode: (infoPanelMode: InfoPanelMode) => void) {
    const languageStrings = React.useContext(LanguageContext);

    const isBusySaving = useSelector((state: RootState) => state.savingInBackground.isBusySaving);
    const userAccount = useSelector((state: RootState) => state.user.account);

    const [menuItem_Replace, setMenuItem_Replace] = React.useState<IContextualMenuItem>();

    React.useEffect(() => {
        if (selectedItems?.length === 1 &&
            ((Array.isArray(selectedItems[0].CheckoutUser) && selectedItems[0].CheckoutUser?.length > 0 && CheckinCheckoutHelper.compareCurrentUser(selectedItems[0].CheckoutUser[0], userAccount.username)) || selectedItems[0].CheckoutUser === '') &&
            selectedItems[0]?.EffectiveBasePermissions?.canDeleteListItem &&
            !selectedItems[0]?.ContentTypeId?.startsWith(SharePointFolderContentTypeIds.folder) &&
            selectedItems[0]?.ProgId !== OneNoteProgId) {
            setMenuItem_Replace(
                {
                    key: "replace",
                    disabled: waitFor === true || isBusySaving === true,
                    text: `${languageStrings.ReplaceOnly}`,
                    iconProps: { iconName: "PostUpdate" },
                    onClick: () => {
                        setInfoPanelMode(InfoPanelMode.Replace)
                        setIsCMFileInfoPanelOpen(true);
                    }
                }
            )
        } else {
            setMenuItem_Replace(null);
        }
    }, [selectedItems, waitFor, userAccount, isBusySaving]);

    return {
        menuItem_Replace
    }
}